import Progress from './Progress'

export default Progress



// WEBPACK FOOTER //
// ./src/components/Progress/index.js